module.exports = __webpack_public_path__ + "images/rank_logo_first-135c6215ed.png";